import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Lock, Home, Loader2 } from "lucide-react";
import { API, TOKEN_KEY } from "./adminApi";

const LoginForm = ({ onSuccess }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!username.trim() || !password) {
      setError("Please enter your username and password.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, {
        username: username.trim(),
        password,
      });
      sessionStorage.setItem(TOKEN_KEY, res.data.token);
      onSuccess?.();
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#EFE7D5] flex items-center justify-center p-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm bg-white border border-gray-200 rounded-xl p-8 shadow-sm"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.25em] text-gray-500 mb-4">
          <Lock className="w-3 h-3" />
          Admin Access
        </div>
        <h1 className="text-2xl font-light text-gray-900 mb-1 tracking-tight">K/AI Admin</h1>
        <p className="text-sm text-gray-500 font-light mb-6">
          Sign in to manage content and waitlists.
        </p>

        <label className="text-[11px] font-mono uppercase tracking-[0.2em] text-gray-600 block mb-1.5">
          Username
        </label>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="ID"
          className="w-full px-3 py-2.5 text-sm bg-white border border-gray-200 rounded-md focus:outline-none focus:border-gray-900 focus:ring-1 focus:ring-gray-900 transition-colors font-light"
          data-testid="admin-username-input"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
        />

        <label className="text-[11px] font-mono uppercase tracking-[0.2em] text-gray-600 block mb-1.5 mt-4">
          Password
        </label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          className="w-full px-3 py-2.5 text-sm bg-white border border-gray-200 rounded-md focus:outline-none focus:border-gray-900 focus:ring-1 focus:ring-gray-900 transition-colors font-light"
          data-testid="admin-password-input"
          autoComplete="off"
        />

        {error && (
          <div className="mt-3 text-xs text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2" data-testid="admin-login-error">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="mt-5 w-full inline-flex items-center justify-center gap-2 bg-gray-900 hover:bg-black text-white text-sm font-medium px-4 py-2.5 rounded-md transition-colors disabled:opacity-60"
          data-testid="admin-login-submit"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Signing in…
            </>
          ) : (
            "Sign in"
          )}
        </button>

        <Link
          to="/"
          className="mt-5 flex items-center justify-center gap-1.5 text-xs text-gray-500 hover:text-gray-900 transition-colors"
        >
          <Home className="w-3 h-3" />
          Back to website
        </Link>
      </form>
    </div>
  );
};

export default LoginForm;
